import SettingsLayout from "@/components/SettingsLayout";
import { csrfToken } from "@/lib/fetchSideEffect";

const OPTIONS = [
  { value: "0", label: "Число задач" },
  { value: "1", label: "Точка — задачи есть, а сколько, не важно" },
];

export default function SettingsAppearance({ sidebarCountDots = false }: { sidebarCountDots?: boolean }) {
  return (
    <SettingsLayout active="appearance" title="Вид">
      <section className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg p-4 space-y-3">
        <div>
          <h2 className="text-sm font-medium text-gray-900 dark:text-white">Счётчики в боковой панели</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Что показывать рядом с «Мой день», корзинами и остальными пунктами.
          </p>
        </div>
        <form method="POST" action="/settings/appearance" className="space-y-3">
          <input type="hidden" name="authenticity_token" value={csrfToken()} />
          <input type="hidden" name="_method" value="patch" />
          <div className="space-y-2">
            {OPTIONS.map((o) => (
              <label key={o.value} className="flex items-center gap-2 text-sm text-gray-900 dark:text-gray-100">
                <input
                  type="radio"
                  name="sidebar_count_dots"
                  value={o.value}
                  defaultChecked={(o.value === "1") === sidebarCountDots}
                />
                {o.label}
              </label>
            ))}
          </div>
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md font-medium text-sm"
          >
            Сохранить
          </button>
        </form>
      </section>
    </SettingsLayout>
  );
}
